'use client';
import React from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import ServicesSection from '@/components/ServicesSection';
import TechPurposeSection from '@/components/TechPurposeSection';
import PortfolioSection from '@/components/PortfolioSection';
import BlogSection from '@/components/BlogSection';
import PartnersSection from '@/components/PartnersSection';
import Footer from '@/components/Footer';

export default function Home() {
  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{
        backgroundColor: '#141618',
        color: '#ffffff',
        fontFamily: "'articulat-cf', -apple-system, BlinkMacSystemFont, 'avenir next', avenir, 'segoe ui', 'helvetica neue', helvetica, arial, sans-serif",
      }}>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <TechPurposeSection />
        <PortfolioSection />
        <BlogSection />
        <PartnersSection />
      </main>
      <Footer />
    </div>
  );
}
